// extracted by mini-css-extract-plugin
module.exports = {"container":"i_T","hero":"i_U","main":"i_V"};